import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../store/ContextStore";

function MultiSelectDropdown(props: { 
    options: any[]; 
    options2: string[]; 
    def: string; 
    setSelectedOption: any; 
    selectedOption: any; 
    filterKey: "OPP" | "POS" | "CLASS" | "PLAYER" | "RES" | "seasons" | "substat" | "stat" | "CONF" | "GAME_TYPE" | "PERIOD_TYPE"; // Added filterKey to target correct field
    disabled:boolean
}) {
    const { options, options2, setSelectedOption, def, selectedOption, filterKey, disabled=false } = props;
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { team } = useContext(AuthContext)
    const [searchString, setSearchString] = useState('');

    const inputRef = useRef<HTMLInputElement | null>(null);

    // Function to filter options based on search string
    const filteredOptions = options.filter((option) => {
        // First check if option exists
        if (!option) return false;
        
        // Then handle the type checking and filtering
        const optionName = typeof option === "object" ? option.name : option;
        return String(optionName).toLowerCase().includes(String(searchString).toLowerCase());
    });
    
    // Function to check if an option is selected
    const isSelected = (option: any) => {
        const filterEntry = selectedOption[filterKey];
        if (!filterEntry) return false;
        return filterEntry.includes(typeof option === "object" ? option.code : option);
    };
    

    //Function to use lighter tone of theme color
    const rgbaFromHex = (hex: string, opacity: number): string => {
        // Remove the hash at the start if it exists
        hex = hex.replace('#', '');
      
        // Convert hex to RGB components
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
      
        // Return RGBA color string
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

    const handleSelect = (option: any) => {
        let newValue = option;
        setSelectedOption(filterKey, newValue);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
                setSearchString("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isOpen && inputRef.current) {
          inputRef?.current?.focus(); // Focus the input when it is rendered
        }
    }, [isOpen]);

    return (
        // <div ref={dropdownRef} className="w-full relative inline-block bg-[#FFFFFF] border border-[#D3D3D3] rounded-lg">
        <div ref={dropdownRef} className={`w-full relative inline-block bg-[#FFFFFF] border border-[#D3D3D3] rounded-lg  ${disabled ? "opacity-50 pointer-events-none" : ""}`}>
            {!isOpen && <button
                id="dropdownInformationButton"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full text-[#000000] font-primary font-medium text-sm rounded-lg px-5 py-2.5 text-center inline-flex justify-between items-center"
                type="button"
            >
                {def}
                <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                </svg>
            </button>}
            {/*search input*/}
            {isOpen && <input
                ref={inputRef} 
                type="text"
                placeholder="Search option"
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                className="w-full text-[#000000] font-primary font-medium text-sm rounded-lg px-5 py-2.5 inline-flex justify-between items-center"
            />}
            {/*search input*/}

            {isOpen && (
                <div id="dropdownInformation" className="w-full z-10  absolute left-0 mt-1 bg-white divide-y divide-[#E3E3E3] rounded-lg border border-[#DEE7F4] max-h-48 overflow-y-auto custom-scrollbar">
                    <ul className="py-2 text-[#000000] text-sm max-h-48 overflow-y-auto custom-scrollbar" aria-labelledby="dropdownInformationButton">
                        {filteredOptions.map((option, index) => (
                            <li key={`options-${index}`} className="p-1">
                                <div
                                    onClick={() => handleSelect(option)}
                                    className="flex items-center w-full rounded-md px-[4px] py-[6px] text-left font-normal font-primary hover:bg-[#EDF1F9] hover:font-semibold "
                                        style={{
                                            backgroundColor : isSelected(option) ? rgbaFromHex(team.colorCode, 0.2) :""
                                        }}    
                                    >
                                    <label className="flex items-center space-x-2 cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation(); 
                                            handleSelect(option); 
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            readOnly
                                            checked={isSelected(option)}
                                            className="peer hidden"
                                        />
                                        <div
                                            className="h-[18px] w-[18px] rounded-md border-2 border-gray-400 peer-checked:bg-current peer-checked:border-transparent flex items-center justify-center"
                                            style={{ backgroundColor: isSelected(option) ? team.colorCode : "transparent" }}
                                        >
                                            {isSelected(option) && (
                                                <svg className="w-3 h-3 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M20 6L9 17l-5-5" />
                                                </svg>
                                            )}
                                        </div>
                                        <span className="text-sm font-primary font-normal text-black">
                                            {typeof option === "object" ? option.name : option}
                                        </span>
                                    </label>
                                </div>
                            </li>
                        ))}
                    </ul>

                    {options2.length > 0 && (
                        <div className="max-h-48 overflow-y-auto custom-scrollbar">
                            <hr className="border-t " />
                            <ul className="py-2 text-[#000000] text-sm">
                                {options2.map((option, index) => (
                                    <li key={`options2-${index}`}>
                                        <button
                                            onClick={() => handleSelect(option)}
                                            className={`block w-full px-4 py-2 text-left font-normal font-primary hover:bg-[#EDF1F9] hover:font-semibold 
                                                ${isSelected(option) ? "bg-[#DEE7F4] font-semibold" : ""}`}
                                        >
                                            {option}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default MultiSelectDropdown;
